import { Injectable, Inject, Optional, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { FileUploader, FileUploadModule } from 'ng2-file-upload';
import { DocumentControlModuleConfigToken } from '@mt-ng2/document-control-config';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from 'ng2-file-upload';

function MtDocumentComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelementStart(4, "div", 3);
    ɵngcc0.ɵɵtext(5, "Drop files here");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(7, "\n            ");
    ɵngcc0.ɵɵelementStart(8, "div", 4);
    ɵngcc0.ɵɵtext(9, "\n                ");
    ɵngcc0.ɵɵelementStart(10, "div");
    ɵngcc0.ɵɵtext(11, "or select a file using the file uploader");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(12, "\n                ");
    ɵngcc0.ɵɵelement(13, "input", 5);
    ɵngcc0.ɵɵtext(14, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(15, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("uploader", ctx_r0.uploader);
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵproperty("uploader", ctx_r0.uploader);
} }
const defaultModuleConfig = {
    allowedMimeType: ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'],
    maxFileSize: 1 * 1024 * 1024,
};
class DocumentControlModuleConfig {
    constructor(config) {
        Object.assign(this, defaultModuleConfig, config);
    }
}
DocumentControlModuleConfig.ɵfac = function DocumentControlModuleConfig_Factory(t) { return new (t || DocumentControlModuleConfig)(ɵngcc0.ɵɵinject(DocumentControlModuleConfigToken, 8)); };
DocumentControlModuleConfig.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DocumentControlModuleConfig, factory: DocumentControlModuleConfig.ɵfac });
DocumentControlModuleConfig.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DocumentControlModuleConfigToken,] }, { type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DocumentControlModuleConfig, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DocumentControlModuleConfigToken]
            }, {
                type: Optional
            }] }]; }, null); })();

class MtDocumentComponent {
    constructor(config) {
        this.config = config;
        // allowedMimeType and maxFileSize are handled using private variables and setters
        // so that when they are set, we can check if the uploader has already been initialized
        // if it has, then we need to reinitialize
        this._allowedMimeType = this.config.allowedMimeType;
        this._maxFileSize = this.config.maxFileSize;
        this.headerTitle = 'Upload Document';
        this.onAddingFileFailed = new EventEmitter();
        this.onAfterAddingFile = new EventEmitter();
        this.afterInitialLoad = false;
    }
    set allowedMimeType(value) {
        this._allowedMimeType = value;
        if (this.afterInitialLoad) {
            this.initializeUploader();
        }
    }
    get allowedMimeType() {
        return this._allowedMimeType;
    }
    set maxFileSize(value) {
        this._maxFileSize = value;
        if (this.afterInitialLoad) {
            this.initializeUploader();
        }
    }
    get maxFileSize() {
        return this._maxFileSize;
    }
    ngOnInit() {
        this.initializeUploader();
        this.afterInitialLoad = true;
    }
    initializeUploader() {
        this.uploader = new FileUploader({
            allowedMimeType: this._allowedMimeType,
            isHTML5: true,
            maxFileSize: this._maxFileSize,
        });
        this.uploader.onWhenAddingFileFailed = (item, filter, options) => this.addingFileFailed(item, filter, options);
        this.uploader.onAfterAddingFile = (item) => this.afterAddingFile(item);
    }
    addingFileFailed(item, filter, options) {
        let errorMessage;
        switch (filter.name) {
            case 'fileSize':
                errorMessage = `Maximum upload size exceeded (${item.size} of ${this._maxFileSize} allowed)`;
                break;
            case 'mimeType':
                const allowedTypes = this._allowedMimeType.join(', ');
                errorMessage = `Type "${item.type}" is not allowed. Allowed types: "${allowedTypes}"`;
                break;
            default:
                errorMessage = `Unknown error (filter is ${filter.name})`;
        }
        this.onAddingFileFailed.emit(errorMessage);
    }
    afterAddingFile(file) {
        this.onAfterAddingFile.emit(file);
    }
}
MtDocumentComponent.ɵfac = function MtDocumentComponent_Factory(t) { return new (t || MtDocumentComponent)(ɵngcc0.ɵɵdirectiveInject(DocumentControlModuleConfig)); };
MtDocumentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MtDocumentComponent, selectors: [["mt-document"]], inputs: { headerTitle: "headerTitle", allowedMimeType: "allowedMimeType", maxFileSize: "maxFileSize" }, outputs: { onAddingFileFailed: "onAddingFileFailed", onAfterAddingFile: "onAfterAddingFile" }, decls: 5, vars: 2, consts: [["class", "row", 4, "ngIf"], [1, "row"], [1, "col-xs-4"], ["ng2FileDrop", "", 1, "drop-box", 3, "uploader"], [1, "col-xs-8"], ["type", "file", "ng2FileSelect", "", 3, "uploader"]], template: function MtDocumentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, " ");
        ɵngcc0.ɵɵelementStart(1, "h4");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(3, "\n\n        ");
        ɵngcc0.ɵɵtemplate(4, MtDocumentComponent_div_4_Template, 16, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.headerTitle);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.uploader);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.FileDropDirective, ɵngcc2.FileSelectDirective], encapsulation: 2 });
MtDocumentComponent.ctorParameters = () => [
    { type: DocumentControlModuleConfig }
];
MtDocumentComponent.propDecorators = {
    allowedMimeType: [{ type: Input, args: ['allowedMimeType',] }],
    maxFileSize: [{ type: Input, args: ['maxFileSize',] }],
    headerTitle: [{ type: Input }],
    onAddingFileFailed: [{ type: Output, args: ['onAddingFileFailed',] }],
    onAfterAddingFile: [{ type: Output, args: ['onAfterAddingFile',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MtDocumentComponent, [{
        type: Component,
        args: [{
                selector: 'mt-document',
                template: ` <h4>{{ headerTitle }}</h4>

        <div class="row" *ngIf="uploader">
            <div class="col-xs-4">
                <div ng2FileDrop [uploader]="uploader" class="drop-box">Drop files here</div>
            </div>
            <div class="col-xs-8">
                <div>or select a file using the file uploader</div>
                <input type="file" ng2FileSelect [uploader]="uploader" />
            </div>
        </div>`
            }]
    }], function () { return [{ type: DocumentControlModuleConfig }]; }, { headerTitle: [{
            type: Input
        }], onAddingFileFailed: [{
            type: Output,
            args: ['onAddingFileFailed']
        }], onAfterAddingFile: [{
            type: Output,
            args: ['onAfterAddingFile']
        }], allowedMimeType: [{
            type: Input,
            args: ['allowedMimeType']
        }], maxFileSize: [{
            type: Input,
            args: ['maxFileSize']
        }] }); })();

class MtDocumentControlModule {
}
MtDocumentControlModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MtDocumentControlModule });
MtDocumentControlModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MtDocumentControlModule_Factory(t) { return new (t || MtDocumentControlModule)(); }, providers: [DocumentControlModuleConfig], imports: [[CommonModule, FileUploadModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MtDocumentControlModule, { declarations: function () { return [MtDocumentComponent]; }, imports: function () { return [CommonModule, FileUploadModule]; }, exports: function () { return [MtDocumentComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MtDocumentControlModule, [{
        type: NgModule,
        args: [{
                declarations: [MtDocumentComponent],
                exports: [MtDocumentComponent],
                imports: [CommonModule, FileUploadModule],
                providers: [DocumentControlModuleConfig]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MtDocumentComponent, MtDocumentControlModule, DocumentControlModuleConfig as ɵa };

//# sourceMappingURL=mt-ng2-document-control.js.map